
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import { NavBarComponent } from '../../../shared/nav-bar/nav-bar.component';
import { FooterBannerComponent } from '../footer-banner/footer-banner.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../Utils/_services/api/api.service';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [NavBarComponent, FooterBannerComponent, ToastModule],
  providers: [MessageService],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css'
})
export class LandingPageComponent {
  isAppleLoading = false;
  isAndroidLoading = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService
  ) { }

  onAdminLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  reviewAvatars = [
    { src: 'assets/images/brand-images/brand-1.png', alt: 'Reviewer 1' },
    { src: 'assets/images/brand-images/brand-2.png', alt: 'Reviewer 2' },
    { src: 'assets/images/brand-images/brand-3.png', alt: 'Reviewer 3' },
    { src: 'assets/images/brand-images/brand-4.png', alt: 'Reviewer 4' },

  ];
  onAppStoreClick(event: MouseEvent, platform: 'apple' | 'android'): void {
    event.preventDefault();

    const newTab = window.open('', '_blank');

    if (platform === 'apple') {
      this.isAppleLoading = true;
    } else {
      this.isAndroidLoading = true;
    }

    this.apiService.get<any>({
      Url: `app-management/${environment.AdoreTheBalloonDatingAppId}`,
      BaseUrl: environment.insizonBackendBaseUrl
    }).subscribe({
      next: (res) => {
        const data = res.data;

        if (platform === 'apple') {
          if (!data.isAppReleaseApple) {
            newTab?.close(); // clean up the blank tab
            this.toastr.info('The iOS app is not available yet. Please sign up on our website using the web app.', 'Coming Soon');
            return;
          }
          const anchor = (event.target as HTMLElement).closest('a');
          if (anchor) anchor.href = data.appleAppStoreUrl;

          if (newTab) {
            newTab.location.href = data.appleAppStoreUrl;
          } else {
            window.open(data.appleAppStoreUrl, '_blank');
          }

        } else {
          if (!data.isAppReleaseAndroid) {
            newTab?.close();
            this.toastr.info('The Android app is not available yet. Please sign up on our website using the web app.', 'Coming Soon');
            return;
          }
          const anchor = (event.target as HTMLElement).closest('a');
          if (anchor) anchor.href = data.androidPlayStoreUrl;

          if (newTab) {
            newTab.location.href = data.androidPlayStoreUrl;
          } else {
            window.open(data.androidPlayStoreUrl, '_blank');
          }
        }
      },
      error: () => {
        newTab?.close();
        if (platform === 'apple') {
          this.isAppleLoading = false;
        } else {
          this.isAndroidLoading = false;
        }
        this.toastr.error('Unable to fetch app details. Please try again later.', 'Error');
      },
      complete: () => {
        if (platform === 'apple') {
          this.isAppleLoading = false;
        } else {
          this.isAndroidLoading = false;
        }
      }
    });
  }
}